import Http from "./http";

export const getProductFeaturesAPI = (data) => {
  return Http.post("admin/product/getProductFeatures",data);
};